import { Component, Inject, OnInit } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { Direction } from '@angular/cdk/bidi';
import { AGREE, ALLOW_COOKIES_DESC, CLOSE, DONT_AGREE, PERSONALIZED_BROWSING_EXPERIENCE } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { CookiesService } from 'src/app/@shared/services/cookies/cookies.service';

@Component({
    selector: 'app-cookies-pop-up',
    templateUrl: './cookies-pop-up.component.html',
    styleUrls: ['./cookies-pop-up.component.scss'],
    standalone: false
})
export class CookiesPopUpComponent extends PopUpComponent implements OnInit {

  direction: Direction
  agreeText: string
  dontAgreeText: string
  personalizedExperiencetext: string
  allowUseCookiesDescText: string
  /**
   * a11y: localized aria-label for the new top close (X) button. The popup
   * had no dedicated close affordance before; audit requires every popup to
   * expose one and to land initial focus on it.
   */
  closeText: string

  constructor
    (
      routePlanningService: RoutePlanningService,
      resizeService: ResizeService,
      overlay: Overlay,
      @Inject(POPUP_DATA)
      public readonly data: { onClose: () => any | void },
      private readonly localStorageService: LocalStorageService,
      private readonly languageService: LanguageService
    ) { super(routePlanningService, resizeService, overlay); }

  override ngOnInit(): void {
    super.ngOnInit()
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.agreeText = AGREE[language.language]
      this.dontAgreeText = DONT_AGREE[language.language]
      this.personalizedExperiencetext = PERSONALIZED_BROWSING_EXPERIENCE[language.language]
      this.allowUseCookiesDescText = ALLOW_COOKIES_DESC[language.language]
      this.closeText = CLOSE[language.language]
    })
  }

  handleClick(isCookiesAllowed: boolean) {
    this.localStorageService.setItem(CookiesService.COOKIES_STORAGE_KEY, isCookiesAllowed)
    this.closeCard(isCookiesAllowed);
  }
}
